export enum StorageEnum {
  localStorage = 1,
  sessionStorage = 2
}
